<div class="container landing-container onboarding-page-wrapper">
    <div class="row">
        <div class="col-lg-8 col-xxl-auto">
            <div class="scroll-block" ngbScrollSpy #spy="ngbScrollSpy" rootMargin="-30%" scrollBehavior="auto">
                <div class="data-showcase-grid" ngbScrollSpyFragment="items-1">
                    <!-- (click)="openCompleteInfoModal(completeInfoModal)" -->
                    <h4 class="grid-title">Main Information</h4>
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="data-label">Name</label>
                            <input type="text" class="form-control" placeholder="Enter Name" />
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Type</label>
                            <ng-select [(ngModel)]="typeSelect" class="ng-form-select primary-select"
                                placeholder="Hello">
                                <ng-option *ngFor="let type of types" [value]="type.id">{{type.name}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Cuisine</label>
                            <ng-select [(ngModel)]="cuisineSelect" class="ng-form-select primary-select">
                                <ng-option *ngFor="let cuisine of cuisines"
                                    [value]="cuisine.id">{{cuisine.name}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Price Range</label>
                            <ng-select [(ngModel)]="priceSelect" class="ng-form-select primary-select">
                                <ng-option *ngFor="let prices of prices" [value]="prices.id">{{prices.name}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">City</label>
                            <ng-select [(ngModel)]="citySelect" class="ng-form-select primary-select">
                                <ng-option *ngFor="let citys of cities" [value]="citys.id">{{citys.name}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Address</label>
                            <input type="text" class="form-control" placeholder="Enter Address" value="-" />
                        </div>
                        <div class="col-12">
                            <label class="data-label">Description</label>
                            <textarea class="form-control"></textarea>
                        </div>
                    </div>
                </div>
                <div class="data-showcase-grid" ngbScrollSpyFragment="items-2">
                    <!-- (click)="openConfirmationModal(confirmationModal)" -->
                    <h4 class="grid-title">Details</h4>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="data-label">Business Hours</label>
                                    <!-- <ng-select [(ngModel)]="businessHoursSelect" class="ng-form-select primary-select"
                                            placeholder="-">
                                            <ng-option *ngFor="let businessHours of businessHours"
                                                [value]="businessHours.id">{{businessHours.name}}</ng-option>
                                        </ng-select> -->
                                    <textarea type="text" class="form-control" placeholder="-"
                                        (click)="openAddBusinessHoursModal(addBusinessHoursModal)"></textarea>
                                    <div class="form-control textarea-replica placeholder-shown"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Phone Number</label>
                            <input type="text" class="form-control" placeholder="-" />
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Website</label>
                            <ng-select [(ngModel)]="websiteSelect" class="ng-form-select primary-select"
                                placeholder="-">
                                <ng-option *ngFor="let website of website"
                                    [value]="website.id">{{website.name}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Instagram</label>
                            <input type="text" class="form-control" placeholder="-" />
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Twitter</label>
                            <input type="text" class="form-control" placeholder="-" />
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Business Message</label>
                            <input type="text" class="form-control" value="Our specialty is farming our own carrots" />
                        </div>
                        <div class="col-sm-6">
                            <label class="data-label">Multi Select</label>
                            <ng-select [items]="peoples" [multiple]="true" bindLabel="name" groupBy="gender"
                                [selectableGroup]="true" [closeOnSelect]="false" [(ngModel)]="selectedPeople"
                                class="ng-form-select primary-select multi-check-select">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" />
                                    {{item.gender | uppercase}}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                        class="form-check-input" />
                                    {{item.name}}
                                </ng-template>
                            </ng-select>
                        </div>

                        <div class="col-12">
                            <label class="data-label">Amenities</label>
                            <div class="chip-control-block">
                                <div class="form-btn-wrap d-flex gap-1">
                                    <input type="text" class="form-control" />
                                    <button class="btn btn-text text-uppercase" title="Add">
                                        Add
                                    </button>
                                </div>
                                <ul class="amenities-chip-wrap">
                                    <li>
                                        Seating
                                        <span class="close-span">
                                        </span>
                                    </li>
                                    <li>
                                        Vegan
                                        <span class="close-span"> </span>
                                    </li>
                                    <li>
                                        Delivery
                                        <span class="close-span"> </span>
                                    </li>
                                    <li>
                                        Wi-Fi
                                        <span class="close-span"> </span>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="data-showcase-grid gallery-grid" ngbScrollSpyFragment="items-3">
                    <h4 class="grid-title with-count">Photos <span class="count">19</span></h4>

                    <div class="photo-tab-wrap">
                        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                            <li [ngbNavItem]="1">
                                <button ngbNavLink>Facade <span class="photo-count">4</span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-1.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-2.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-3.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-4.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2">
                                <button ngbNavLink>Interior <span class="photo-count">3</span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-2.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-1.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="3">
                                <button ngbNavLink>Counter <span class="photo-count">1</span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-1.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="4">
                                <button ngbNavLink>Kitchen <span class="photo-count">5</span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-1.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="5">
                                <button ngbNavLink>Seating Area <span class="photo-count">4</span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-1.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="6">
                                <button ngbNavLink>Other <span class="photo-count"></span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="7">
                                <button ngbNavLink>Food and Drink <span class="photo-count">2</span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <div class="gallery-preview">
                                                <div class="img-block">
                                                    <img src="./assets/images/demo-1.jpg" alt="Image">
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit">Edit</button>
                                                    <button class="btn btn-primary" title="Delete">Delete</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="8">
                                <button ngbNavLink>User Submisssions <span class="photo-count"></span></button>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-4">
                                            <div class="file-upload-wrap">
                                                <input type="file">
                                                <div class="upload-inner">
                                                    <img src="./assets/images/ic-add.svg" alt="Add Icon"
                                                        class="add-icon">
                                                    <span>ADD PHOTO</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                        </ul>

                        <div [ngbNavOutlet]="nav" class="mt-2"></div>
                    </div>
                </div>
                <div class="data-showcase-grid food-dish-grid" ngbScrollSpyFragment="items-4">
                    <h4 class="grid-title with-count s-bottom">Menu <span class="count">(42 dishes)</span></h4>
                    <div class="food-tab-outer">
                        <ul ngbNav #dishNav="ngbNav" [(activeId)]="activeDishPanel" class="nav-tabs">
                            <li [ngbNavItem]="1">
                                <button ngbNavLink>Entree</button>
                                <ng-template ngbNavContent>
                                    <div class="food-dish-wrap">
                                        <p>
                                            Data 1
                                        </p>
                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2">
                                <button ngbNavLink>Main</button>
                                <ng-template ngbNavContent>
                                    <div class="food-dish-wrap">
                                        <ul class="dish-ul">
                                            <li>
                                                <img src="./assets/images/dish-1.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit"
                                                        (click)="openEditMenuModal(editMenuModal)">Edit</button>
                                                    <button class="btn btn-primary" title="Delete"
                                                        (click)="openDeleteMenuItemModal(deleteMenuItemModal)">Delete</button>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-8.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                                <div class="cta">
                                                    <button class="btn btn-primary" title="Edit"
                                                        (click)="openEditMenuModal(editMenuModal)">Edit</button>
                                                    <button class="btn btn-primary" title="Delete"
                                                        (click)="openDeleteMenuItemModal(deleteMenuItemModal)">Delete</button>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-2.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-3.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-4.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-5.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-6.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>

                                            <!-- col-2  -->
                                            <li>
                                                <img src="./assets/images/dish-7.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-8.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-2.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-3.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-4.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-5.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-6.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="3">
                                <button ngbNavLink>Sides</button>
                                <ng-template ngbNavContent>
                                    <div class="food-dish-wrap">
                                        <ul class="dish-ul">
                                            <li>
                                                <img src="./assets/images/dish-1.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-8.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-2.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-1.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-8.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-1.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="4">
                                <button ngbNavLink>Dessert</button>
                                <ng-template ngbNavContent>
                                    <div class="food-dish-wrap">
                                        <ul class="dish-ul">
                                            <li>
                                                <img src="./assets/images/dish-1.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-8.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="./assets/images/dish-2.jpg" alt="Food" class="food-preview">
                                                <div class="dish-inner">
                                                    <div class="dish-info-wrap">
                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                        <span class="lines"></span>
                                                        <h4 class="dish-price">$10</h4>
                                                    </div>
                                                    <p class="dish-info">Buffala Mozzarella, Fresh Basil, Parmigiano</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </ng-template>
                            </li>
                        </ul>
                        <button class="btn btn-text btn-add-item text-uppercase d-none d-sm-flex">
                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M9 5.40046L9 3.60046L5.40039 3.60046L5.40039 0.000243983L3.60039 0.000243905L3.60039 3.60046L-1.57371e-07 3.60046L-2.36051e-07 5.40046L3.60039 5.40046L3.60039 9.00024L5.40039 9.00024L5.40039 5.40046L9 5.40046Z"
                                    fill="currentcolor" />
                            </svg>
                            Add Dish
                        </button>
                    </div>

                    <div [ngbNavOutlet]="dishNav" class="mt-2"></div>
                    <button class="btn btn-text btn-add-item text-uppercase d-sm-none">
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M9 5.40046L9 3.60046L5.40039 3.60046L5.40039 0.000243983L3.60039 0.000243905L3.60039 3.60046L-1.57371e-07 3.60046L-2.36051e-07 5.40046L3.60039 5.40046L3.60039 9.00024L5.40039 9.00024L5.40039 5.40046L9 5.40046Z"
                                fill="currentcolor" />
                        </svg>
                        Add Dish
                    </button>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-xxl">
            <div class="onboarding-sidebar" [class.show-onboarding-sidebar]="isOnboardingSidebarActive">
                <ul>
                    <li>
                        <button class="btn" title="Main Information" [ngbScrollSpyItem]="[spy, 'items-1']"
                            (click)="viewOnboardingSideBar()">
                            <span class="icon-block"></span>
                            Main Information
                        </button>
                    </li>
                    <li>
                        <button class="btn" title="Details" [ngbScrollSpyItem]="spy" fragment="items-2"
                            (click)="viewOnboardingSideBar()">
                            <span class="icon-block"></span>
                            Details
                        </button>
                    </li>
                    <li>
                        <button class="btn" title="Photos" [ngbScrollSpyItem]="spy" fragment="items-3"
                            (click)="viewOnboardingSideBar()">
                            <span class="icon-block"></span>
                            Photos

                        </button>
                    </li>
                    <li>
                        <button class="btn" title="Popular Dishes ">
                            <span class="icon-block"></span>
                            Popular Dishes

                        </button>
                    </li>
                    <li>
                        <button class="btn" title="Take Out / Delivery">
                            <span class="icon-block"></span>
                            Take Out / Delivery

                        </button>
                    </li>
                    <li>
                        <button class="btn" title="Menu" [ngbScrollSpyItem]="spy" fragment="items-4">
                            <span class="icon-block"></span>
                            Menu

                        </button>
                    </li>
                    <li>
                        <button class="btn" title="Reviews">
                            <span class="icon-block"></span>
                            Reviews

                        </button>
                    </li>
                    <li>
                        <button class="btn" title="Promotion (Memberhsip Subscription)">
                            <span class="icon-block"></span>
                            Promotion (Memberhsip Subscription)

                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="bottom-action">
        <div class="bottom-action-inner">
            <div class="btn-grps">
                <button class="btn btn-danger" title="Cancel Edits">Cancel Edits</button>
                <button class="btn btn-primary" title="Save Details">Save Details</button>

                <button class="btn btn-fab d-lg-none" (click)="viewOnboardingSideBar()">
                    <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                        xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
                        <path
                            d="m464.883 64.267h-289.233c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h289.232c25.98 0 47.117-21.137 47.117-47.117.001-26.013-21.136-47.149-47.116-47.149z" />
                        <path
                            d="m47.134 64.267c-25.989 0-47.134 21.144-47.134 47.133s21.145 47.133 47.134 47.133 47.133-21.144 47.133-47.133-21.144-47.133-47.133-47.133z" />
                        <path
                            d="m47.134 208.867c-25.989 0-47.134 21.144-47.134 47.133s21.145 47.133 47.134 47.133 47.133-21.144 47.133-47.133-21.144-47.133-47.133-47.133z" />
                        <path
                            d="m47.134 353.467c-25.989 0-47.134 21.144-47.134 47.133s21.145 47.133 47.134 47.133 47.133-21.144 47.133-47.133-21.144-47.133-47.133-47.133z" />
                        <path
                            d="m464.883 208.867h-289.233c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h289.232c25.98 0 47.117-21.137 47.117-47.117.001-26.013-21.136-47.149-47.116-47.149z" />
                        <path
                            d="m464.883 353.467h-289.233c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h289.232c25.98 0 47.117-21.137 47.117-47.117.001-26.012-21.136-47.149-47.116-47.149z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Edit Menu Modal -->
<ng-template #editMenuModal let-modal>
    <div class="modal-body">
        <div class="data-showcase-grid">
            <h4 class="grid-title with-count s-bottom">Menu <span class="count">(42 dishes)</span></h4>
            <div class="edit-food-menu-wrap">
                <div class="row">
                    <div class="col-md-8 order-1 order-md-0">
                        <div class="row">
                            <div class="col-12">
                                <label class="data-label">Title</label>
                                <input type="text" class="form-control" placeholder="Enter Title"
                                    value="Pizza Margherita" />
                            </div>
                            <div class="col-8 col-sm-7">
                                <label class="data-label">Type</label>
                                <ng-select [(ngModel)]="typeSelect" class="ng-form-select primary-select">
                                    <ng-option *ngFor="let type of types" [value]="type.id">{{type.name}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="col-4 col-sm-5">
                                <label class="data-label">Price</label>
                                <input type="text" class="form-control" placeholder="Enter Price" value="$10" />
                            </div>
                            <div class="col-12">
                                <label class="data-label">Description</label>
                                <textarea
                                    class="form-control text-dark fw-normal fst-italic">Buffala Mozzarella, Fresh Basil, Parmigiano</textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 order-md-1">
                        <div class="file-upload-wrap">
                            <input type="file" *ngIf="!FoodPreviewAdded">
                            <div class="upload-inner" *ngIf="!FoodPreviewAdded">
                                <img src="./assets/images/ic-add-light.svg" alt="Add Icon" class="add-icon">
                                <span>ADD PHOTO</span>
                            </div>
                            <img src="./assets/images/food-1.jpg" alt="Food" class="food-preview"
                                *ngIf="FoodPreviewAdded">

                        </div>
                        <div class="file-upload-cta">
                            <button class="btn btn-primary btn-sm" title="Delete">Delete</button>
                        </div>
                    </div>
                </div>
                <div class="btn-grps">
                    <button class="btn btn-outline-primary" title="Cancel"
                        (click)="modal.close('Close click')">Cancel</button>
                    <button class="btn btn-primary" title="Save">Save</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Edit Menu Modal -->
<ng-template #deleteMenuItemModal let-modal>
    <div class="modal-body">
        <h2>Sure want to delete it?</h2>
        <h5 class="food-dish-name">Pizza Margherita</h5>
        <div class="btn-grps">
            <button class="btn btn-outline-primary" title="Cancel" (click)="modal.close('Close click')">Cancel</button>
            <button class="btn btn-primary" title="Delete">Delete</button>
        </div>
    </div>
</ng-template>

<!-- Complete Information Modal -->
<ng-template #completeInfoModal let-modal>
    <div class="modal-head">
        <button class="btn btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
        <div class="img-wrap">
            <img src="./assets/images/ic-com-info.svg" alt="Icon">
        </div>
        <h2 class="title-text" ngbAutofocus>Complete Information</h2>
        <h5 class="info-text">
            Business registration needs to be completed prior to adding images or products, please complete Main
            Information and
            Details before proceeding
        </h5>
        <div class="btn-grps">
            <button class="btn btn-outline-primary" title="Okay">Okay</button>
        </div>
    </div>
</ng-template>

<!-- Complete Information Modal -->
<ng-template #confirmationModal let-modal>
    <div class="modal-head">
        <button class="btn btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
        <div class="img-wrap">
            <img src="./assets/images/ic-confirmation.svg" alt="Icon">
        </div>
        <h2 class="title-text" ngbAutofocus>Confirmation</h2>
        <h5 class="info-text">
            Business registration needs to be completed prior to adding images or products, do you confirm that the
            information
            entered is your
            correct business details
            (can be edited later)
        </h5>
        <div class="btn-grps">
            <button class="btn btn-outline-primary" title="Okay">Okay</button>
        </div>
    </div>
</ng-template>

<!-- Add Business Hours Modal -->
<ng-template #addBusinessHoursModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Add Business Hours</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"
            title="Close Modal"></button>
    </div>
    <div class="modal-body">
        <h5 class="modal-info-text">Set the standard hours for this place</h5>

        <div class="add-hour-wrap">
            <div class="single-day-stack">
                <div class="div-aside">
                    <div class="day-block">
                        <h5>Sunday</h5>
                    </div>
                    <div class="switch-block">
                        <div class="switch-stack">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="sunSwitch">
                                <label class="form-check-label" for="sunSwitch">Closed</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timepicker-block">
                    <div class="inner-stack">
                        <!-- <input aria-label="default time" [ngxTimepicker]="timeSunstart" [value]="'10:00 am'"
                            class="form-control" [disabled]="true">
                        <ngx-material-timepicker #timeSunstart></ngx-material-timepicker>
                        <p>To</p>
                        <input aria-label="default time" [ngxTimepicker]="timeSunend" [value]="'10:00 am'"
                            class="form-control" [disabled]="true">
                        <ngx-material-timepicker #timeSunend></ngx-material-timepicker> -->
                        <ng-select [(ngModel)]="typeSelect" class="ng-form-select primary-select">
                            <ng-option *ngFor="let type of types" [value]="type.id">{{type.name}}</ng-option>
                        </ng-select>
                        <p>To</p>
                        <ng-select [(ngModel)]="typeSelect" class="ng-form-select primary-select">
                            <ng-option *ngFor="let type of types" [value]="type.id">{{type.name}}</ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="single-day-stack">
                <div class="div-aside">
                    <div class="day-block">
                        <h5>Monday</h5>
                    </div>
                    <div class="switch-block">
                        <div class="switch-stack">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="monSwitch">
                                <label class="form-check-label" for="monSwitch">Closed</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timepicker-block">
                    <div class="inner-stack">
                        <input aria-label="default time" [ngxTimepicker]="timeMonstart" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeMonstart></ngx-material-timepicker>
                        <p>To</p>
                        <input aria-label="default time" [ngxTimepicker]="timeMonEnd" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeMonEnd></ngx-material-timepicker>
                    </div>
                </div>
            </div>
            <div class="single-day-stack">
                <div class="div-aside">
                    <div class="day-block">
                        <h5>Tuesday</h5>
                    </div>
                    <div class="switch-block">
                        <div class="switch-stack">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="tueSwitch">
                                <label class="form-check-label" for="tueSwitch">Closed</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timepicker-block">
                    <div class="inner-stack">
                        <input aria-label="default time" [ngxTimepicker]="timeTuestart" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeTuestart></ngx-material-timepicker>
                        <p>To</p>
                        <input aria-label="default time" [ngxTimepicker]="timeTueEnd" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeTueEnd></ngx-material-timepicker>
                    </div>
                </div>
            </div>
            <div class="single-day-stack">
                <div class="div-aside">
                    <div class="day-block">
                        <h5>Wednesday</h5>
                    </div>
                    <div class="switch-block">
                        <div class="switch-stack">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="wedSwitch">
                                <label class="form-check-label" for="wedSwitch">Closed</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timepicker-block">
                    <div class="inner-stack">
                        <input aria-label="default time" [ngxTimepicker]="timeWedStart" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeWedStart></ngx-material-timepicker>
                        <p>To</p>
                        <input aria-label="default time" [ngxTimepicker]="timeWedEnd" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeWedEnd></ngx-material-timepicker>
                    </div>
                </div>
            </div>
            <div class="single-day-stack">
                <div class="div-aside">
                    <div class="day-block">
                        <h5>Thursday</h5>
                    </div>
                    <div class="switch-block">
                        <div class="switch-stack">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="thuSwitch">
                                <label class="form-check-label" for="thuSwitch">Closed</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timepicker-block">
                    <div class="inner-stack">
                        <input aria-label="default time" [ngxTimepicker]="timeThuStart" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeThuStart></ngx-material-timepicker>
                        <p>To</p>
                        <input aria-label="default time" [ngxTimepicker]="timeThuEnd" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeThuEnd></ngx-material-timepicker>
                    </div>
                </div>
            </div>
            <div class="single-day-stack">
                <div class="div-aside">
                    <div class="day-block">
                        <h5>Friday</h5>
                    </div>
                    <div class="switch-block">
                        <div class="switch-stack">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="friSwitch">
                                <label class="form-check-label" for="friSwitch">Closed</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timepicker-block">
                    <div class="inner-stack">
                        <input aria-label="default time" [ngxTimepicker]="timeFriStart" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeFriStart></ngx-material-timepicker>
                        <p>To</p>
                        <input aria-label="default time" [ngxTimepicker]="timeFriEnd" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeFriEnd></ngx-material-timepicker>
                    </div>
                </div>
            </div>
            <div class="single-day-stack">
                <div class="div-aside">
                    <div class="day-block">
                        <h5>Saturday</h5>
                    </div>
                    <div class="switch-block">
                        <div class="switch-stack">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="satSwitch">
                                <label class="form-check-label" for="satSwitch">Closed</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timepicker-block">
                    <div class="inner-stack">
                        <input aria-label="default time" [ngxTimepicker]="timeSatStart" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeSatStart></ngx-material-timepicker>
                        <p>To</p>
                        <input aria-label="default time" [ngxTimepicker]="timeSatEnd" [value]="'10:00 am'"
                            class="form-control">
                        <ngx-material-timepicker #timeSatEnd></ngx-material-timepicker>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-grps">
            <button class="btn btn-outline-primary" title="Cancel">Cancel</button>
            <button class="btn btn-primary" title="Add Hours" (click)="modal.close('Close click')">Add Hours</button>
        </div>
    </div>
</ng-template>